import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trackingUrl", "trackingIdentifier", "direction"];
import { CUIStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import LoginButton from './LoginButton';
import SignupButton from './SignupButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoginSignupButtons = _ref => {
  let {
      trackingUrl,
      trackingIdentifier,
      direction = 'row'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CUIStack, Object.assign({
    direction: direction
  }, rest, {
    children: [/*#__PURE__*/_jsx(SignupButton, {
      variant: "primary",
      trackingUrl: trackingUrl,
      trackingIdentifier: trackingIdentifier
    }), /*#__PURE__*/_jsx(LoginButton, {
      trackingIdentifier: trackingIdentifier
    })]
  }));
};
export default LoginSignupButtons;